<template>
  <div
    id="app"
    class="content background-home"
    :style="sidebarStyle"
    :data-image="backgroundImage"
  >
    <div class="height-home">
      <div class="m-0 mt-2 height-home">
        <div class="row height-home">
          <div class="col-md-12  col-lg-12 col-sm-12 ">
            <!-- aqui -->
            <card
              class="card-user mt-2 background-card align-center card-style"
            >
              <div class="row">
                <div
                  class="col-md-12 max"
                  style="text-align: center"
                  v-if="!isForgPsw"
                >
                  <h1 class="card-title" style="color: white ">
                    <b>Sobre Nós</b>
                  </h1>
                  <p
                    class="mt-4"
                    style="color: white;  font-size: min(30px, 3vw); "
                  >
                    <b>
                      Empresa especializada na implantação de sistemas solar
                      fotovoltaicos. Com sede na cidade do Recife e escritório
                      no Estado da Paraíba. Atua no Nordeste brasileiro. Tem por
                      missão oferecer serviço de excelente qualidade ao cliente,
                      dando-lhe todo suporte e transparência na implantação e
                      manutenção de seus sistemas fotovoltaicos. São valores da
                      empresa a responsabilidade social, sustentabilidade
                      ambiental e prioridade à vida.
                    </b>
                  </p>
                  <div>
                    <img
                      style="width: 20%"
                      src="../../public/img/joule-logo.png"
                      alt=""
                    />
                  </div>
                  <p
                    class="mt-2"
                    style="color: white;  font-size: min(30px, 3vw); "
                  >
                    <b>
                      Já somamos mais de 3 MWp de potência instalada na
                      tecnologia de sistema solar fotovoltaica.
                    </b>
                  </p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import AnunciosServices from 'src/services/anuncios';
import Card from 'src/components/Cards/Card.vue';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  data() {
    return {
      backgroundImage: '/img/home.jpg',
      anuncios: []
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      AnunciosServices.listarTodos()
        .then(response => {
          this.anuncios = _.get(response, 'data.result');
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno ao carregar os anúncios. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundSize:
          'cover' /* Resize the background image to cover the entire container */
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 120%;
}
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center 10;
}

.height-home {
  height: 100%;
}

.card-style {
}

.background-card {
  background-color: rgba(36, 68, 109, 0.589);
}

.background-home {
  height: -webkit-fill-available;
}

.join-logo {
  align-self: center;
}

.height-join {
  height: 70%;
}

.whatsapp-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  cursor: pointer;
  box-shadow: 0 0 5px #444;
  transition-duration: 0.1s;
}

.carousel-position {
  position: absolute;
  bottom: 10px;
}

title-style {
  color: white !important;
}

.whatsapp-button:hover {
  box-shadow: 0 0 10px #444;
}

.min p {
  font-size: 10vw;
}
</style>
